window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.ai_advisor_chat = window.locales.am.ai_advisor_chat || {};window.locales.am.ai_advisor_chat.greeting_message = window.locales.am.ai_advisor_chat.greeting_message || {};window.locales.am.ai_advisor_chat.greeting_message = {...window.locales.am.ai_advisor_chat.greeting_message, ...{
    "helloAgain": "ሠላም እንደገና!",
    "goodDay": "እንደምን ዋልክ.",
    "welcomeBack": "እንኳን ደህና መጣህ!",
    "dayOfWeek": "መልካም {dayOfWeek}፣ እና እንኳን በደህና ተመልሰው መጡ!",
    "welcomeBackName": "እንኳን ደህና መጡ፣ {name}!",
    "hello": "ሀሎ!",
    "hi": "ሃይ!",
    "greetingsName": "ሰላም፣ {name}!",
    "hiThere": "ሃይ እንዴት ናችሁ!",
    "helloHuman": "ሰላም, የሰው ጓደኛ!",
    "morning": "ምልካም እድል!",
    "afternoon": "እንደምን አረፈድክ!",
    "evening": "አንደምን አመሸህ!",
    "salutations": "ሰላምታ!",
    "niceToSeeYou": "እንደገና በማየቴ ደስ ብሎኛል!",
    "helloAndNiceToSeeYou": "ሰላም፣ እና እንደገና በማየቴ ደስ ብሎኛል!",
    "niceToSeeYouName": "እንደገና በማየቴ ደስ ብሎኛል፣ {name}!",
    "greetingsAndHappyDay": "ሰላምታ እና መልካም {dayOfWeek}!",
    "greatToHaveYou": "{name}፣ እርስዎን በመመለስዎ በጣም ጥሩ!",
    "heyThere": "ሰላም፣ {name}!",
    "doYouHave": "ለእኔ ጥያቄ አለህ?",
    "whatCanI": "በምን ልረዳህ እችላለሁ?",
    "whatQuery": "የትኛው ጥያቄ ነው መንገዴን ያመጣህ?",
    "whatTopic": "የትኛውን ርዕስ ማሰስ ይፈልጋሉ?",
    "whatSubjectMatter": "ዛሬ የማወቅ ጉጉትህን ያነሳሳው የትኛው ርዕሰ ጉዳይ ነው?",
    "whatSubject": "ዛሬ ልንወያይበት የሚገባው ጉዳይ ምንድን ነው?",
    "whatTopicRequires": "ትኩረታችንን የሚፈልገው የትኛው ርዕስ ነው?",
    "howMayI": "ዛሬ የአካዳሚክ ጉዞዎን እንዴት መደገፍ እችላለሁ?",
    "anythingICanHelp": "ልረዳህ የምችለው ነገር አለ?",
    "whatQuestion": "ምን ጥያቄ አመጣህ?",
    "howCanI": "እንዴት ልረዳ እችላለሁ?",
    "whatInformation": "ዛሬ ምን መረጃ እንድታገኝ ልረዳህ እችላለሁ?",
    "areaOfInterest": "ማሰስ የሚፈልጉት የተወሰነ የፍላጎት ቦታ አለ?",
    "whatChallenges": "ምን አይነት ተግዳሮቶች አጋጥመውኛል እርዳታ ልሰጥባቸው እችላለሁ?",
    "whichConcept": "ወደ የትኛው ፅንሰ-ሀሳብ ወይም ርዕስ አንድ ላይ ለመጥለቅ ይፈልጋሉ?",
    "whatsOnYourMind": "ለማብራራት ወይም ለማብራራት የምረዳው በአእምሮዎ ውስጥ ያለው ምንድን ነው?",
    "0": "እሁድ",
    "1": "ሰኞ",
    "2": "ማክሰኞ",
    "3": "እሮብ",
    "4": "ሐሙስ",
    "5": "አርብ",
    "6": "ቅዳሜ",
    "anyQuestions": "ስለ ኮርስ ስራ ወይም ፕሮግራምዎ እኔ ልረዳው የምችለው ጥያቄ አለ?",
    "myMission": "ሰላም፣ {name} ! የእኔ ተልእኮ {institutionName} ተማሪዎች በትምህርታቸው እንዲሳካላቸው መርዳት ነው።",
    "haveWonderfulDay": "ግሩም ቀን ይሁንልህ! 👋",
    "hopeYouWillApply": "ለቀጣዩ ቡድናችን እንደሚያመለክቱ ተስፋ አደርጋለሁ! 👋",
    "completeInterview": "የመግቢያ ቃለ መጠይቁን ማጠናቀቅዎን አይርሱ፣ እና መልካም ቀን! 👋",
    "hopeYouWillJoin": "ከእኛ ጋር እንደምትቀላቀል ተስፋ አደርጋለሁ! 👍",
    "seeYouSoon": "አንግናኛለን! 👋",
    "congratulationsOnAcceptance": "ወደ {institutionName} ፣ {name} ስለተቀበልክ እንኳን ደስ አለህ! {botName} በ {startDate} ላይ በክፍል መጀመሪያ ላይ ይከፈታል።",
    "signupHiName": "🖐 ሰላም፣ {name} !",
    "signupMyMission": "የእኔ ተልእኮ {institutionName} ተማሪዎች በትምህርታቸው እንዲሳካላቸው መርዳት ነው፣ እና በሚቀጥለው ቡድናችን ውስጥ እርስዎን በማግኘቴ ደስተኛ ነኝ! 🚀",
    "signupHappyToHelp": "ስለ ፕሮግራሙ ወይም ስለ አፕሊኬሽኑ ሂደት የማወቅ ጉጉት ካሎት ይጠይቁ - በማገዝ ደስተኛ ነኝ!",
    "appliedHiName": "⏳ ሰላም፣ {name} !",
    "appliedImHere": "ስለ ማመልከቻው ሂደት ያለዎትን ማንኛውንም ጥያቄ ለመመለስ እዚህ መጥቻለሁ። ስለወደፊቱ ወይም እንዴት እንደሚዘጋጁ የበለጠ ማወቅ ይፈልጋሉ? ብቻ አሳውቀኝ!",
    "notOfferedAdmissionHiName": "ሰላም፣ {name} !",
    "notOfferedAdmissionMyMission": "የእኔ ተልእኮ {institutionName} ተማሪዎች በትምህርታቸው እንዲሳካላቸው መርዳት ነው። ልረዳው የምችለው ነገር አለ?",
    "offeredAdmissionHiName": "🖐 ሰላም፣ {name} !",
    "offeredAdmissionExcitingNews": "አስደሳች ዜና - ወደ {institutionName} ገብተሃል! 🎉 ስለ ፕሮግራሙ ወይም ምን እንደሚጠብቁ ማንኛውም አይነት ጥያቄ ካሎት፣ ለመርዳት ደስተኛ ነኝ!",
    "offerExpiredHiName": "⏳ ሰላም፣ {name}",
    "offerExpiredImHere": "ወደፊት እንደገና ስለማመልከት ማንኛውም አይነት ጥያቄ ካሎት እዚህ ነኝ። እንዴት መርዳት እንደምችል አሳውቀኝ!",
    "registeredNotCurrentCongratulations": "🎉 እንኳን ደስ አለህ፣ {name} ! በይፋ ገብተሃል! 🚀",
    "registeredNotCurrentClassesStartOn": "ትምህርቶች የሚጀምሩት በ {startDate} ነው፣ እና እርስዎ በሚዘጋጁበት ጊዜ በማንኛውም ነገር ለማገዝ እዚህ ነኝ። ምን እንደሚጠብቁ ወይም እንዴት እንደሚዘጋጁ ጠቃሚ ምክሮችን ይፈልጋሉ? ብቻ ጠይቅ!",
    "includedOrGraduatedNiceToMeetYou": "ስለተዋወቅን ደስ ብሎኛል፣ {name} !",
    "includedOrGraduatedWelcomeBack": "እንኳን ደህና መጡ፣ {name} !",
    "includedOrGraduatedImHere": "የትምህርት እና የአስተዳደር ጥያቄዎችዎን ለማገዝ እዚህ ነኝ የኮርስ ስራ እየሄዱ ወይም ድጋፍ ይፈልጋሉ። ተጨማሪ እርዳታ ከፈለጉ የኛ አካዳሚክ እና ድጋፍ ሰጪ ቡድኖችም ይገኛሉ።",
    "includedOrGraduatedLearningAndImproving": "እኔ ሁልጊዜ እየተማርኩ እና እየተሻሻልኩ ነው፣ ስለዚህ ምን አዲስ ነገር እንዳለ ለማየት ደጋግመው ይመልከቱ!",
    "includedOrGraduatedHowCanIHelp": "ይህን ግምት ውስጥ በማስገባት ዛሬ ምን ልረዳህ እችላለሁ?",
    "didNotGraduateHiName": "💡 ሰላም፣ {name} ።",
    "didNotGraduateIKnowThings": "ነገሮች ሁል ጊዜ እንደታቀደው እንደማይሄዱ አውቃለሁ፣ ነገር ግን አሁንም እርስዎን ለመደገፍ እዚህ ነኝ። ማድረግ የምችለው ነገር ካለ—ሃብቶችን መጋራት፣ ቀጣይ እርምጃዎችን መወያየት ወይም ጥያቄዎችን መመለስ - ብቻ አሳውቀኝ።"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.ai_advisor_chat = window.locales.ar.ai_advisor_chat || {};window.locales.ar.ai_advisor_chat.greeting_message = window.locales.ar.ai_advisor_chat.greeting_message || {};window.locales.ar.ai_advisor_chat.greeting_message = {...window.locales.ar.ai_advisor_chat.greeting_message, ...{
    "helloAgain": "مرحبا مجددا!",
    "goodDay": "يوم جيد.",
    "welcomeBack": "مرحبًا بعودتك!",
    "dayOfWeek": "{dayOfWeek} سعيد ، ومرحبا بكم من جديد!",
    "welcomeBackName": "مرحبًا بك مرة أخرى ، {name}!",
    "hello": "مرحبًا!",
    "hi": "أهلاً!",
    "greetingsName": "تحياتي ، {name}!",
    "hiThere": "أهلاً!",
    "helloHuman": "مرحبًا ، صديق بشري!",
    "morning": "صباح الخير!",
    "afternoon": "مساء الخير!",
    "evening": "مساء الخير!",
    "salutations": "التحية!",
    "niceToSeeYou": "جميل ان اراك مرة اخرى!",
    "helloAndNiceToSeeYou": "مرحبا ، ومن الجيد رؤيتك مرة أخرى!",
    "niceToSeeYouName": "تشرفت برؤيتك مرة أخرى ، {name}!",
    "greetingsAndHappyDay": "تحية طيبة {dayOfWeek} وسعيد!",
    "greatToHaveYou": "{name} ، رائع بعودتك!",
    "heyThere": "مرحبًا {name}!",
    "doYouHave": "هل لديك سؤال بالنسبة لي؟",
    "whatCanI": "بماذا يمكنني مساعدتك؟",
    "whatQuery": "ما هو الاستعلام الذي أتى بك إلى طريقي؟",
    "whatTopic": "ما الموضوع الذي ترغب في استكشافه؟",
    "whatSubjectMatter": "ما الموضوع الذي أثار فضولك اليوم؟",
    "whatSubject": "ما الموضوع الذي يجب أن نتناوله اليوم؟",
    "whatTopicRequires": "ما الموضوع الذي يتطلب انتباهنا؟",
    "howMayI": "كيف يمكنني دعم رحلتك الأكاديمية اليوم؟",
    "anythingICanHelp": "هل يمكنني مساعدتك في حل أي شيء؟",
    "whatQuestion": "ما السؤال الذي تحضره؟",
    "howCanI": "كيف يمكنني أن أقدم المساعدة؟",
    "whatInformation": "ما هي المعلومات التي يمكنني مساعدتك في الكشف عنها اليوم؟",
    "areaOfInterest": "هل هناك مجال اهتمام معين تود استكشافه؟",
    "whatChallenges": "ما التحديات التي تواجهها والتي يمكنني تقديم المساعدة بشأنها؟",
    "whichConcept": "ما هو المفهوم أو الموضوع الذي ترغب في الغوص فيه معًا؟",
    "whatsOnYourMind": "ما الذي يدور في ذهنك ويمكنني المساعدة في توضيحه أو شرحه؟",
    "0": "الأحد",
    "1": "الاثنين",
    "2": "يوم الثلاثاء",
    "3": "الأربعاء",
    "4": "يوم الخميس",
    "5": "جمعة",
    "6": "السبت",
    "anyQuestions": "هل لديك أي أسئلة حول الدورات الدراسية أو برنامجك يمكنني المساعدة فيها؟",
    "myMission": "مرحبًا {name} ! مهمتي هي مساعدة طلاب {institutionName} على النجاح في دراساتهم.",
    "haveWonderfulDay": "اتمنى لك يوم جميل! 👋",
    "hopeYouWillApply": "آمل أن تتقدم إلى مجموعتنا القادمة! 👋",
    "completeInterview": "لا تنس إكمال مقابلة القبول الخاصة بك، واستمتع بيوم رائع! 👋",
    "hopeYouWillJoin": "أتمنى أن تنضم إلينا! 👍",
    "seeYouSoon": "اراك قريبا! 👋",
    "congratulationsOnAcceptance": "أهنئك على قبولك في {institutionName} ، {name} ! يتم فتح {botName} عند بدء الفصل الدراسي في {startDate} .",
    "signupHiName": "🖐 مرحبًا {name} !",
    "signupMyMission": "مهمتي هي مساعدة طلاب {institutionName} على النجاح في دراستهم، وسأكون سعيدًا برؤيتك في مجموعتنا القادمة! 🚀",
    "signupHappyToHelp": "إذا كنت مهتمًا بالبرنامج أو عملية التقديم، فقط اسأل - سأكون سعيدًا بالمساعدة!",
    "appliedHiName": "⏳ مرحبًا {name} !",
    "appliedImHere": "أنا هنا للإجابة على أي استفسارات لديكم حول عملية التقديم. هل ترغبون بمعرفة المزيد عن الخطوات القادمة أو كيفية الاستعداد؟ تواصلوا معي!",
    "notOfferedAdmissionHiName": "مرحبًا {name} !",
    "notOfferedAdmissionMyMission": "مهمتي هي مساعدة طلاب {institutionName} على النجاح في دراستهم. هل هناك أي شيء يمكنني مساعدتهم به؟",
    "offeredAdmissionHiName": "🖐 مرحبًا {name} !",
    "offeredAdmissionExcitingNews": "أخبار سارة - تم قبولك في {institutionName} ! 🎉 إذا كانت لديك أي أسئلة حول البرنامج أو ما تتوقعه، يسعدني مساعدتك!",
    "offerExpiredHiName": "⏳ مرحبًا {name} .",
    "offerExpiredImHere": "أنا هنا إذا كانت لديك أي أسئلة حول إعادة التقديم مستقبلًا. أخبرني كيف يمكنني مساعدتك!",
    "registeredNotCurrentCongratulations": "🎉 ألف مبروك يا {name} ! تم قبولك رسميًا! 🚀",
    "registeredNotCurrentClassesStartOn": "تبدأ الدروس في {startDate} ، وأنا هنا لمساعدتك في أي شيء أثناء استعدادك. هل تريد نصائح حول ما تتوقعه أو كيفية الاستعداد؟ اسأل فقط!",
    "includedOrGraduatedNiceToMeetYou": "يسعدني أن ألتقي بك، {name} !",
    "includedOrGraduatedWelcomeBack": "مرحبًا بك مرة أخرى، {name} !",
    "includedOrGraduatedImHere": "أنا هنا لمساعدتك في أسئلتك الأكاديمية والإدارية، سواءً كنتَ بصدد دراسة المقررات الدراسية أو تحتاج إلى دعم. كما أن فرقنا الأكاديمية وفرق الدعم متاحةٌ أيضًا إذا احتجتَ إلى مساعدة إضافية.",
    "includedOrGraduatedLearningAndImproving": "أنا أتعلم وأتحسن دائمًا، لذا راجع دائمًا لمعرفة ما هو جديد!",
    "includedOrGraduatedHowCanIHelp": "مع وضع ذلك في الاعتبار، ما الذي يمكنني مساعدتك به اليوم؟",
    "didNotGraduateHiName": "💡 مرحبًا {name} .",
    "didNotGraduateIKnowThings": "أعلم أن الأمور لا تسير دائمًا كما هو مخطط لها، لكنني ما زلت هنا لدعمكم. إذا كان هناك أي شيء يمكنني فعله - سواءً كان مشاركة الموارد، أو مناقشة الخطوات التالية، أو الإجابة على الأسئلة - فأخبروني بذلك."
}
};window.locales.en = window.locales.en || {};window.locales.en.ai_advisor_chat = window.locales.en.ai_advisor_chat || {};window.locales.en.ai_advisor_chat.greeting_message = window.locales.en.ai_advisor_chat.greeting_message || {};window.locales.en.ai_advisor_chat.greeting_message = {...window.locales.en.ai_advisor_chat.greeting_message, ...{
                                
    "signupHiName": "🖐 Hi, {name}!",
    "signupMyMission": "My mission is to help {institutionName} students succeed in their studies, and I'd be thrilled to see you in our next cohort! 🚀",
    "signupHappyToHelp": "If you're curious about the program or the application process, just ask—I'm happy to help!",

    "appliedHiName": "⏳ Hi, {name}!",
    "appliedImHere": "I'm here to answer any questions you have about the application process. Want to learn more about what's ahead or how to prepare? Just let me know!",

    "notOfferedAdmissionHiName": "Hi, {name}!",
    "notOfferedAdmissionMyMission": "My mission is to help {institutionName} students succeed in their studies. Is there anything I can help with?",

    "offeredAdmissionHiName": "🖐 Hi, {name}!",
    "offeredAdmissionExcitingNews": "Exciting news—you've been admitted to {institutionName}! 🎉  If you have any questions about the program or what to expect, I'm happy to help!",

    "offerExpiredHiName": "⏳ Hi, {name}.",
    "offerExpiredImHere": "I'm here if you have any questions about reapplying in the future. Let me know how I can help!",

    "registeredNotCurrentCongratulations": "🎉 Congratulations, {name}! You're officially in! 🚀",
    "registeredNotCurrentClassesStartOn": "Classes start on {startDate}, and I'm here to help with anything as you get ready. Want tips on what to expect or how to prepare? Just ask!",

    "includedOrGraduatedNiceToMeetYou": "Nice to meet you, {name}!",
    "includedOrGraduatedWelcomeBack": "Welcome back, {name}!",
    "includedOrGraduatedImHere": "I'm here to help with your academic and administrative questions, whether you're navigating coursework or need support. Our Academic and Support teams are also available if you ever need extra assistance.",
    "includedOrGraduatedLearningAndImproving": "I'm always learning and improving, so check back often to see what's new!",
    "includedOrGraduatedHowCanIHelp": "With that in mind, what can I help you with today?",

    "didNotGraduateHiName": "💡 Hi, {name}.",
    "didNotGraduateIKnowThings": "I know things don't always go as planned, but I'm still here to support you. If there's anything I can do—whether it's sharing resources, discussing next steps, or answering questions—just let me know.",

                          
    "helloAgain": "Hello again!",
    "goodDay": "Good day.",
    "welcomeBack": "Welcome back!",
    "dayOfWeek": "Happy {dayOfWeek}, and welcome back!",
    "welcomeBackName": "Welcome back, {name}!",
    "hello": "Hello!",
    "hi": "Hi!",
    "greetingsName": "Greetings, {name}!",
    "hiThere": "Hi there!",
    "helloHuman": "Hello, human friend!",
    "morning": "Good morning!",
    "afternoon": "Good afternoon!",
    "evening": "Good evening!",
    "salutations": "Salutations!",
    "niceToSeeYou": "Nice to see you again!",
    "helloAndNiceToSeeYou": "Hello, and nice to see you again!",
    "niceToSeeYouName": "Nice to see you again, {name}!",
    "greetingsAndHappyDay": "Greetings and happy {dayOfWeek}!",
    "greatToHaveYou": "{name}, great to have you back!",
    "heyThere": "Hey there, {name}!",

                                 
    "doYouHave": "Do you have a question for me?",
    "whatCanI": "What can I assist you with?",
    "whatQuery": "What query brings you my way?",
    "whatTopic": "What topic would you like to explore?",
    "anyQuestions": "Any questions about coursework or your program that I can help with?",
    "whatSubjectMatter": "What subject matter has piqued your curiosity today?",
    "whatSubject": "What subject should we tackle today?",
    "whatTopicRequires": "What topic requires our attention?",
    "howMayI": "How may I support your academic journey today?",
    "anythingICanHelp": "Anything I can help you solve?",
    "whatQuestion": "What question do you bring?",
    "howCanI": "How can I help?",
    "whatInformation": "What information can I help you uncover today?",
    "areaOfInterest": "Is there a specific area of interest you'd like to explore?",
    "whatChallenges": "What challenges are you facing that I can provide assistance with?",
    "whichConcept": "Which concept or topic would you like to dive into together?",
    "whatsOnYourMind": "What's on your mind that I can help clarify or explain?",

                       
    "0": "Sunday",
    "1": "Monday",
    "2": "Tuesday",
    "3": "Wednesday",
    "4": "Thursday",
    "5": "Friday",
    "6": "Saturday",

                                          
    "myMission": "Hi, {name}! My mission is to help {institutionName} students succeed in their studies.",
    "haveWonderfulDay": "Have a wonderful day! 👋",
    "hopeYouWillApply": "I hope you'll apply to our next cohort! 👋",
    "completeInterview": "Don't forget to complete your admissions interview, and have a wonderful day! 👋",
    "hopeYouWillJoin": "I hope you'll join us! 👍",
    "congratulationsOnAcceptance": "Congratulations on your acceptance to {institutionName}, {name}! {botName} unlocks at class start on {startDate}.",
    "seeYouSoon": "See you soon! 👋"
}
};window.locales.es = window.locales.es || {};window.locales.es.ai_advisor_chat = window.locales.es.ai_advisor_chat || {};window.locales.es.ai_advisor_chat.greeting_message = window.locales.es.ai_advisor_chat.greeting_message || {};window.locales.es.ai_advisor_chat.greeting_message = {...window.locales.es.ai_advisor_chat.greeting_message, ...{
    "helloAgain": "¡Hola de nuevo!",
    "goodDay": "Buen día.",
    "welcomeBack": "¡Bienvenido de nuevo!",
    "dayOfWeek": "¡Feliz {dayOfWeek} y bienvenido de nuevo!",
    "welcomeBackName": "¡Bienvenido de nuevo, {name}!",
    "hello": "¡Hola!",
    "hi": "¡Hola!",
    "greetingsName": "¡Saludos, {name}!",
    "hiThere": "¡Hola!",
    "helloHuman": "¡Hola, amigo humano!",
    "morning": "¡Buen día!",
    "afternoon": "¡Buenas tardes!",
    "evening": "¡Buenas noches!",
    "salutations": "¡Saludos!",
    "niceToSeeYou": "¡Qué gusto verte de nuevo!",
    "helloAndNiceToSeeYou": "¡Hola, y encantado de verte de nuevo!",
    "niceToSeeYouName": "¡Encantado de verte de nuevo, {name}!",
    "greetingsAndHappyDay": "¡Saludos y feliz {dayOfWeek}!",
    "greatToHaveYou": "{name}, ¡qué bueno tenerte de regreso!",
    "heyThere": "¡Hola, {name}!",
    "doYouHave": "Tienes alguna pregunta para mi?",
    "whatCanI": "¿En qué puedo ayudarte?",
    "whatQuery": "¿Qué consulta te trae por mi camino?",
    "whatTopic": "¿Qué tema te gustaría explorar?",
    "whatSubjectMatter": "¿Qué tema ha despertado tu curiosidad hoy?",
    "whatSubject": "¿Qué tema debemos abordar hoy?",
    "whatTopicRequires": "¿Qué tema requiere nuestra atención?",
    "howMayI": "¿Cómo puedo apoyar su viaje académico hoy?",
    "anythingICanHelp": "¿Algo que pueda ayudarte a resolver?",
    "whatQuestion": "que pregunta traes?",
    "howCanI": "¿Cómo puedo ayudar?",
    "whatInformation": "¿Qué información puedo ayudarte a descubrir hoy?",
    "areaOfInterest": "¿Hay un área específica de interés que le gustaría explorar?",
    "whatChallenges": "¿A qué desafíos se enfrenta con los que puedo brindarle asistencia?",
    "whichConcept": "¿En qué concepto o tema les gustaría profundizar juntos?",
    "whatsOnYourMind": "¿Qué tienes en mente que pueda ayudarte a aclarar o explicar?",
    "0": "Domingo",
    "1": "Lunes",
    "2": "Martes",
    "3": "Miércoles",
    "4": "Jueves",
    "5": "Viernes",
    "6": "Sábado",
    "anyQuestions": "¿Alguna pregunta sobre el trabajo del curso o su programa con la que pueda ayudar?",
    "myMission": "¡Hola, {name} ! Mi misión es ayudar a los estudiantes {institutionName} a tener éxito en sus estudios.",
    "haveWonderfulDay": "¡Ten un día maravilloso! 👋",
    "hopeYouWillApply": "¡Espero que postules a nuestra próxima cohorte! 👋",
    "completeInterview": "¡No olvides completar tu entrevista de admisión y que tengas un día maravilloso! 👋",
    "hopeYouWillJoin": "¡Espero que te unas a nosotros! 👍",
    "seeYouSoon": "¡Nos vemos pronto! 👋",
    "congratulationsOnAcceptance": "¡Felicitaciones por tu aceptación en {institutionName} , {name} ! {botName} se desbloquea al inicio de la clase el {startDate} .",
    "signupHiName": "🖐 ¡Hola, {name} !",
    "signupMyMission": "Mi misión es ayudar a los estudiantes {institutionName} a tener éxito en sus estudios, ¡y me encantaría verte en nuestra próxima cohorte! 🚀",
    "signupHappyToHelp": "Si tiene curiosidad sobre el programa o el proceso de solicitud, simplemente pregunte. ¡Estaré encantado de ayudarle!",
    "appliedHiName": "⏳ ¡Hola, {name} !",
    "appliedImHere": "Estoy aquí para responder cualquier pregunta que tengas sobre el proceso de solicitud. ¿Quieres saber más sobre lo que viene o cómo prepararte? ¡Házmelo saber!",
    "notOfferedAdmissionHiName": "Hola, {name} !",
    "notOfferedAdmissionMyMission": "Mi misión es ayudar a los estudiantes {institutionName} a tener éxito en sus estudios. ¿Puedo ayudar en algo?",
    "offeredAdmissionHiName": "🖐 ¡Hola, {name} !",
    "offeredAdmissionExcitingNews": "¡Buenas noticias! Has sido admitido en {institutionName} . 🎉 Si tienes alguna pregunta sobre el programa o qué esperar, ¡con gusto te ayudaré!",
    "offerExpiredHiName": "⏳ Hola, {name} .",
    "offerExpiredImHere": "Estoy aquí si tienes alguna pregunta sobre cómo volver a postularte en el futuro. ¡Avísame cómo puedo ayudarte!",
    "registeredNotCurrentCongratulations": "¡Felicidades, {name} ! ¡Ya estás dentro! 🚀",
    "registeredNotCurrentClassesStartOn": "Las clases empiezan el {startDate} y estoy aquí para ayudarte con todo lo que necesites mientras te preparas. ¿Necesitas consejos sobre qué esperar o cómo prepararte? ¡Solo pregúntame!",
    "includedOrGraduatedNiceToMeetYou": "¡Encantado de conocerte, {name} !",
    "includedOrGraduatedWelcomeBack": "¡Bienvenido de nuevo, {name} !",
    "includedOrGraduatedImHere": "Estoy aquí para ayudarte con tus preguntas académicas y administrativas, ya sea que estés navegando por el curso o necesites apoyo. Nuestros equipos académicos y de apoyo también están disponibles si necesitas ayuda adicional.",
    "includedOrGraduatedLearningAndImproving": "¡Siempre estoy aprendiendo y mejorando, así que vuelve a visitarnos con frecuencia para ver qué hay de nuevo!",
    "includedOrGraduatedHowCanIHelp": "Con esto en mente ¿En qué puedo ayudarte hoy?",
    "didNotGraduateHiName": "💡Hola, {name} .",
    "didNotGraduateIKnowThings": "Sé que las cosas no siempre salen como se planean, pero sigo aquí para apoyarte. Si hay algo que pueda hacer, ya sea compartir recursos, hablar sobre los próximos pasos o responder preguntas, házmelo saber."
}
};window.locales.it = window.locales.it || {};window.locales.it.ai_advisor_chat = window.locales.it.ai_advisor_chat || {};window.locales.it.ai_advisor_chat.greeting_message = window.locales.it.ai_advisor_chat.greeting_message || {};window.locales.it.ai_advisor_chat.greeting_message = {...window.locales.it.ai_advisor_chat.greeting_message, ...{
    "helloAgain": "Ciao di nuovo!",
    "goodDay": "Buona giornata.",
    "welcomeBack": "Bentornato!",
    "dayOfWeek": "Buon {dayOfWeek} e bentornato!",
    "welcomeBackName": "Bentornato, {name}!",
    "hello": "Ciao!",
    "hi": "CIAO!",
    "greetingsName": "Saluti, {name}!",
    "hiThere": "Ciao!",
    "helloHuman": "Ciao, amico umano!",
    "morning": "Buongiorno!",
    "afternoon": "Buon pomeriggio!",
    "evening": "Buonasera!",
    "salutations": "Saluti!",
    "niceToSeeYou": "Che bello rivederti!",
    "helloAndNiceToSeeYou": "Ciao, e piacere di rivederti!",
    "niceToSeeYouName": "Piacere di rivederti, {name}!",
    "greetingsAndHappyDay": "Saluti e felice {dayOfWeek}!",
    "greatToHaveYou": "{name}, è un piacere riaverti!",
    "heyThere": "Ciao, {name}!",
    "doYouHave": "Hai una domanda per me?",
    "whatCanI": "In cosa posso aiutarti?",
    "whatQuery": "Quale domanda ti porta a modo mio?",
    "whatTopic": "Quale argomento vorresti approfondire?",
    "whatSubjectMatter": "Quale argomento ha stuzzicato la tua curiosità oggi?",
    "whatSubject": "Quale argomento dobbiamo affrontare oggi?",
    "whatTopicRequires": "Quale argomento richiede la nostra attenzione?",
    "howMayI": "Come posso sostenere il tuo percorso accademico oggi?",
    "anythingICanHelp": "Qualcosa che posso aiutarti a risolvere?",
    "whatQuestion": "Che domanda porti?",
    "howCanI": "Come posso aiutare?",
    "whatInformation": "Quali informazioni posso aiutarti a scoprire oggi?",
    "areaOfInterest": "C'è un'area di interesse specifica che vorresti esplorare?",
    "whatChallenges": "Quali sfide stai affrontando per le quali posso fornire assistenza?",
    "whichConcept": "In quale concetto o argomento vorreste tuffarvi insieme?",
    "whatsOnYourMind": "Cosa hai in mente che posso aiutarti a chiarire o spiegare?",
    "0": "Domenica",
    "1": "Lunedi",
    "2": "Martedì",
    "3": "Mercoledì",
    "4": "Giovedì",
    "5": "Venerdì",
    "6": "Sabato",
    "anyQuestions": "Hai domande sui corsi o sul tuo programma con cui posso aiutarti?",
    "myMission": "Ciao, {name} ! La mia missione è aiutare gli studenti {institutionName} ad avere successo nei loro studi.",
    "haveWonderfulDay": "Buona giornata! 👋",
    "hopeYouWillApply": "Spero che farai domanda per il nostro prossimo gruppo! 👋",
    "completeInterview": "Non dimenticare di completare il colloquio di ammissione e trascorri una splendida giornata! 👋",
    "hopeYouWillJoin": "Spero che ti unirai a noi! 👍",
    "seeYouSoon": "Arrivederci! 👋",
    "congratulationsOnAcceptance": "Congratulazioni per la tua accettazione in {institutionName} , {name} ! {botName} si sblocca all'inizio del corso il {startDate} .",
    "signupHiName": "🖐 Ciao, {name} !",
    "signupMyMission": "La mia missione è aiutare gli studenti {institutionName} ad avere successo nei loro studi e sarei entusiasta di vederti nel nostro prossimo gruppo! 🚀",
    "signupHappyToHelp": "Se sei curioso di sapere di più sul programma o sulla procedura di candidatura, chiedi pure: sarò felice di aiutarti!",
    "appliedHiName": "⏳ Ciao, {name} !",
    "appliedImHere": "Sono qui per rispondere a qualsiasi domanda tu abbia sulla procedura di candidatura. Vuoi saperne di più su cosa ti aspetta o su come prepararti? Fammi sapere!",
    "notOfferedAdmissionHiName": "Ciao, {name} !",
    "notOfferedAdmissionMyMission": "La mia missione è aiutare gli studenti {institutionName} ad avere successo nei loro studi. Posso aiutarti in qualcosa?",
    "offeredAdmissionHiName": "🖐 Ciao, {name} !",
    "offeredAdmissionExcitingNews": "Notizie entusiasmanti: sei stato ammesso a {institutionName} ! 🎉 Se hai domande sul programma o su cosa aspettarti, sarò felice di aiutarti!",
    "offerExpiredHiName": "⏳ Ciao, {name} .",
    "offerExpiredImHere": "Sono qui per qualsiasi domanda su come ricandidarti in futuro. Fammi sapere come posso aiutarti!",
    "registeredNotCurrentCongratulations": "🎉 Congratulazioni, {name} ! Sei ufficialmente iscritto! 🚀",
    "registeredNotCurrentClassesStartOn": "Le lezioni iniziano il {startDate} e sono qui per aiutarti con qualsiasi cosa ti prepari. Vuoi consigli su cosa aspettarti o su come prepararti? Chiedi pure!",
    "includedOrGraduatedNiceToMeetYou": "Piacere di conoscerti, {name} !",
    "includedOrGraduatedWelcomeBack": "Bentornato, {name} !",
    "includedOrGraduatedImHere": "Sono qui per aiutarti con le tue domande accademiche e amministrative, che tu stia gestendo i corsi o abbia bisogno di supporto. I nostri team di supporto accademico e di supporto sono disponibili anche per qualsiasi ulteriore necessità.",
    "includedOrGraduatedLearningAndImproving": "Continuo ad imparare e migliorare, quindi torna spesso a trovarmi per scoprire le novità!",
    "includedOrGraduatedHowCanIHelp": "Considerando tutto questo, come posso aiutarti oggi?",
    "didNotGraduateHiName": "💡 Ciao, {name} .",
    "didNotGraduateIKnowThings": "So che le cose non vanno sempre come previsto, ma sono sempre qui per supportarti. Se c'è qualcosa che posso fare, che si tratti di condividere risorse, discutere i prossimi passi o rispondere alle tue domande, fammelo sapere."
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.ai_advisor_chat = window.locales.zh.ai_advisor_chat || {};window.locales.zh.ai_advisor_chat.greeting_message = window.locales.zh.ai_advisor_chat.greeting_message || {};window.locales.zh.ai_advisor_chat.greeting_message = {...window.locales.zh.ai_advisor_chat.greeting_message, ...{
    "helloAgain": "再一次问好！",
    "goodDay": "再会。",
    "welcomeBack": "欢迎回来！",
    "dayOfWeek": "{dayOfWeek} 快乐，欢迎回来！",
    "welcomeBackName": "欢迎回来，{name}！",
    "hello": "你好！",
    "hi": "你好！",
    "greetingsName": "你好，{name}！",
    "hiThere": "你好呀！",
    "helloHuman": "你好，人类朋友！",
    "morning": "早上好！",
    "afternoon": "下午好！",
    "evening": "晚上好！",
    "salutations": "敬礼！",
    "niceToSeeYou": "很高兴再次见到你！",
    "helloAndNiceToSeeYou": "你好，很高兴再次见到你！",
    "niceToSeeYouName": "很高兴再次见到你，{name}！",
    "greetingsAndHappyDay": "问候和快乐 {dayOfWeek}！",
    "greatToHaveYou": "{name}，很高兴你回来了！",
    "heyThere": "嘿，{name}！",
    "doYouHave": "你有什么问题要问我吗？",
    "whatCanI": "我能帮你什么？",
    "whatQuery": "什么问题给你带来了我的方式？",
    "whatTopic": "您想探索什么主题？",
    "whatSubjectMatter": "今天是什么主题激起了您的好奇心？",
    "whatSubject": "我们今天应该处理什么主题？",
    "whatTopicRequires": "什么主题需要我们注意？",
    "howMayI": "我如何支持你今天的学术之旅？",
    "anythingICanHelp": "有什么我可以帮你解决的吗？",
    "whatQuestion": "你提出什么问题？",
    "howCanI": "我能提供什么帮助？",
    "whatInformation": "今天我能帮你揭开哪些信息？",
    "areaOfInterest": "是否有您想探索的特定兴趣领域？",
    "whatChallenges": "您面临哪些挑战，我可以提供帮助？",
    "whichConcept": "您想一起探讨哪个概念或主题？",
    "whatsOnYourMind": "你有什么想法我可以帮助澄清或解释？",
    "0": "星期日",
    "1": "周一",
    "2": "周二",
    "3": "周三",
    "4": "周四",
    "5": "星期五",
    "6": "周六",
    "anyQuestions": "关于课程作业或您的项目有任何问题我可以帮助解决吗？",
    "myMission": "嗨， {name} ！我的使命是帮助{institutionName}学生取得学业成功。",
    "haveWonderfulDay": "祝你有美好的一天！ 👋",
    "hopeYouWillApply": "我希望你能申请加入我们的下一批！ 👋",
    "completeInterview": "别忘了完成你的招生面试，祝你有美好的一天！ 👋",
    "hopeYouWillJoin": "我希望你能加入我们！ 👍",
    "seeYouSoon": "再见！ 👋",
    "congratulationsOnAcceptance": "恭喜您被{institutionName}录取， {name} ！ {botName}将于{startDate}课程开始时解锁。",
    "signupHiName": "🖐 嗨， {name} ！",
    "signupMyMission": "我的使命是帮助{institutionName}学生在学业上取得成功，我很高兴在下一批学生中见到你！🚀",
    "signupHappyToHelp": "如果您对该计划或申请流程感到好奇，请直接询问 - 我很乐意为您提供帮助！",
    "appliedHiName": "⏳嗨， {name} ！",
    "appliedImHere": "我在这里解答您关于申请流程的任何疑问。想了解更多关于申请流程或准备事宜的信息吗？欢迎随时联系我！",
    "notOfferedAdmissionHiName": "你好， {name} ！",
    "notOfferedAdmissionMyMission": "我的使命是帮助{institutionName}学生取得学业成功。有什么我可以帮忙的吗？",
    "offeredAdmissionHiName": "🖐 嗨， {name} ！",
    "offeredAdmissionExcitingNews": "激动人心的消息——你已被{institutionName}录取！🎉 如果你对这个项目或未来发展有任何疑问，我很乐意为你解答！",
    "offerExpiredHiName": "⏳ 你好， {name} 。",
    "offerExpiredImHere": "如果您以后对重新申请有任何疑问，欢迎随时联系我。请告诉我如何提供帮助！",
    "registeredNotCurrentCongratulations": "🎉 恭喜， {name} ！你正式入选啦！🚀",
    "registeredNotCurrentClassesStartOn": "课程将于{startDate}开始，我会随时为您提供一切准备帮助。想知道课程安排或准备方法吗？尽管问！",
    "includedOrGraduatedNiceToMeetYou": "很高兴认识你， {name} ！",
    "includedOrGraduatedWelcomeBack": "欢迎回来， {name} ！",
    "includedOrGraduatedImHere": "无论您是在学习课程还是需要支持，我都会随时为您解答学术和行政方面的问题。如果您需要额外帮助，我们的学术和支持团队也随时待命。",
    "includedOrGraduatedLearningAndImproving": "我一直在学习和进步，所以请经常回来看看有什么新东西！",
    "includedOrGraduatedHowCanIHelp": "考虑到这一点，今天我能为您提供什么帮助？",
    "didNotGraduateHiName": "💡 你好， {name} 。",
    "didNotGraduateIKnowThings": "我知道事情并不总是按计划进行，但我仍然会在这里支持你。如果我能帮上什么忙——无论是分享资源、讨论后续步骤，还是解答问题——请告诉我。"
}
};